var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.ReactPrice,{attrs:{"variant":_vm.variant},on:{"price-change":_setup.handlePriceChange}}),_c('span',{staticClass:"csr-commerce-price"},[_vm._v(_vm._s(_setup.productPrice))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }